import React from "react";
import { CardList } from "./CardList";

const Card = () => {
  return (
    <div className="card-container">
      {CardList.map((item, index) => (
        <div
          key={index}
          className="card"
          data-aos={index % 2 === 0 ? "fade-left" : "fade-right"}
          data-aos-delay="100"
        >
          <div
            className="card-content"
            data-aos={index % 2 === 0 ? "fade-up-left" : "fade-up-right"}
            data-aos-delay="100"
          >
            <h2 className="card-title">{item.title}</h2>
            <p className="card-description">{item.description}</p>
          </div>
          <img
            className="card-img"
            src={require(`../../Assets/Images/new-features/${item.img}`)}
            alt="new features"
          />
        </div>
      ))}
    </div>
  );
};

export default Card;
